















































































































import { IMergeSelected } from "@/models/IMergeSelected";
import { IWhooingSection } from "@/models/IWhooingSection";
import {
  IWhoooingGetEntriesParams,
  WhoooingGetEntriesParams,
} from "@/models/IWhoooingGetEntriesPayload";
import { WhooingEntryModel } from "@/models/WhooingEntryModel";
import fns from "date-fns";
import { interfaces } from "mocha";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  getWhooingEntries,
  IWhooingEntriesResults,
} from "../api/GetWhooingEntries";
import DuplicationGroup from "../components/DuplicationGroup.vue";
import MergeEntriesModal from "../components/MergeEntriesModal.vue";
import {
  EntriesDuplicationHelper,
  IDuplicationOptions,
} from "../helpers/EntriesDuplicationHelper";
import { UserHelper } from "../store/modules/User";
import { UserModule } from "../store/store";
import { WhooingDate } from "../utils/WhooingDate";

@Component({
  components: {
    DuplicationGroup,
    MergeEntriesModal,
  },
})
export default class CheckDuplication extends Vue {
  public mergeModalValue: {
    mergeSelected: IMergeSelected;
    entryIds: number[];
  } | null = null;

  // computed
  /** 섹션 리스트 */
  get sections(): IWhooingSection[] {
    return UserModule.sectionList;
  }

  /** 섹션 Id */
  get sId(): string {
    if (this.$route.query && this.$route.query.sId) {
      return this.$route.query.sId as string;
    } else {
      const sId = this.sections[0].section_id;
      this.sId = sId;
      return sId;
    }
  }
  /** 섹션 Id */
  set sId(v) {
    this.$router.replace({
      name: this.$route.name,
      query: { sId: v },
    });
  }
  get sIdName() {
    return UserHelper.GetSectionName(this.sId);
  }
  // data
  public searchForm: ISearchForm = this.createSearchForm();
  public duplicationOptions: IDuplicationOptions = this.createDuplicateOptions();

  public menu = {
    startDate: false,
    endDate: false,
  };
  public state = {
    isLoadingRawData: false,
  };
  public rawData: WhooingEntryModel[] = [];
  public duplicatData: { [index: string]: WhooingEntryModel[] } = {};

  // watch
  @Watch("duplicationOptions", { deep: true })
  public onDuplicationOptions() {
    // console.log("onDuplicationOptions");
    this.duplicatData = this.getDuplicatData(this.rawData);
  }

  // methods
  public clearSearchForm() {
    this.searchForm = this.createSearchForm();
    this.duplicationOptions = this.createDuplicateOptions();
  }

  public getDuplicatData(
    rawData = this.rawData,
  ): { [index: string]: WhooingEntryModel[] } {
    if (rawData.length < 1) {
      return {};
    }
    const duplicationList = EntriesDuplicationHelper.duplicateEntries(
      rawData,
      this.duplicationOptions,
    );

    const result: { [index: string]: WhooingEntryModel[] } = {};
    for (const key of Object.keys(duplicationList)) {
      const item = duplicationList[key];
      if (item.length > 1) {
        result[key] = item;
      }
    }
    return result;
  }

  // 거래불러오기
  public async getRawData() {
    this.state.isLoadingRawData = true;
    const params = this.createGetRawDataParams();
    const result: WhooingEntryModel[] = [];
    this.rawData = result;
    while (this.rawData === result) {
      const { results } = await getWhooingEntries(params);
      const { rows } = results;
      result.push(...results.rows);
      if (rows.length !== params.limit) {
        break;
      }
      if(result.length >= 1000) {
        alert("최대 1000건까지만 지원합니다. 검색조건을 조정해주세요.");
        break;
      }
      params.max = Number(rows[rows.length-1].entry_date);
    }
    if (this.rawData === result) {
      this.duplicatData = this.getDuplicatData(this.rawData);
    }
    this.state.isLoadingRawData = false;
  }

  public mounted() {
    this.getRawData();
  }

  // 거래불러오기 조건 설정
  private createGetRawDataParams(): WhoooingGetEntriesParams {
    const params = new WhoooingGetEntriesParams(this.sId);
    params.start_date = WhooingDate.ConvertNumber(
      new Date(this.searchForm.startDate),
    );
    params.end_date = WhooingDate.ConvertNumber(
      new Date(this.searchForm.endDate),
    );

    return params;
  }

  // 검색조건 초기화
  private createSearchForm(): ISearchForm {
    const today = new Date();
    const startDate = new Date(today.getFullYear(), today.getMonth());
    const endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);

    return {
      startDate: fns.format(startDate, "YYYY-MM-DD"),
      endDate: fns.format(endDate, "YYYY-MM-DD"),
    };
  }

  // 중복검색조건 초기화
  private createDuplicateOptions(): IDuplicationOptions {
    const duplicationOptions: IDuplicationOptions = {
      isSameMoney: true,
      isSameItem: false,
      isSameLeft: false,
      isSameRight: true,
      isSameDate: true,
    };
    return duplicationOptions;
  }
}

interface ISearchForm {
  startDate: string;
  endDate: string;
}
